module.exports = __webpack_public_path__ + "img/horizondulac.fe4ba7e6.jpg";